<h3>{{ texts.searchHandelssortiment }}</h3>

<div class="bg-white p-0 pb-3">
    <form [formGroup]="formFilterHandelssortiment" name="formFilterHandelssortiment" id="formSearchMinaHandelssortiment" role="form" class="form"
        (ngSubmit)="searchForHandelssortiment()" autocomplete="off">
        <div class="row">
            <div class="col-md-8">
                <rask-input type="text" [label]="texts.wildcardSearch" class="wildcardcell" aid="inputWildcardSearch" formControlName="wildcardSearch"></rask-input>
                <rask-radiobutton-group [label]="texts.aktiv" aid="aktivRadio" [buttons]="activetypes" formControlName="aktiv" [rule]=""></rask-radiobutton-group>
                <rask-button aid="buttonSok" (click)="searchForHandelssortiment()" color="secondary">{{ texts.labelSearch }}</rask-button>
                <rask-button aid="buttonClear" color="secondary" negative (click)="clearHandelssortimentSearchParams()">{{ texts.labelClear }}</rask-button>
            </div>
        </div>
    </form>
</div>
